export default __webpack_public_path__ + "static/media/trigo.eba71760.png";